import React from 'react';
import PropTypes from 'prop-types';
import withRouter from 'with-router'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { styled } from '@mui/material/styles';
import Stepper from '@mui/material/Stepper';
import Divider from '@mui/material/Divider';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';
import classNames from 'classnames';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormHelperText from '@mui/material/FormHelperText';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

import RichTextEditor from './RichTextEditor'
import LoadingIndicator from './LoadingIndicator';
import { TextField } from '@mui/material';

const PREFIX = 'NotificationEditor';
const classes = {
  root: `${PREFIX}-root`,
  button: `${PREFIX}-button`,
  reset: `${PREFIX}-reset`,
  actionsContainer: `${PREFIX}-actionsContainer`,
  resetContainer: `${PREFIX}-resetContainer`,
  textField: `${PREFIX}-textField`,
  inputField: `${PREFIX}-inputField`,
  disabledField: `${PREFIX}-disabledField`,
  contentContainer: `${PREFIX}-contentContainer`,
  formControl: `${PREFIX}-formControl`,
  group: `${PREFIX}-group`,
};

const StyledPaper = styled(Paper)(({ theme }) => ({
  [`&.${classes.root}`]: {
    width: '100%',
    marginTop: 20,
  },
  [`& .${classes.button}`]: {
    marginTop: theme.spacing(1.5),
    marginRight: theme.spacing(1),
  },
  [`& .${classes.reset}`]: {
    position: 'absolute',
    right: 24
  },
  [`& .${classes.actionsContainer}`]: {
    //marginBottom: theme.spacing(2),
  },
  [`& .${classes.resetContainer}`]: {
    padding: theme.spacing(3),
  },
  [`& .${classes.textField}`]: {
    margin: '12px 0',
    padding: 0,
  },
  [`& .${classes.inputField}`]: {
    padding: '12px 14px !important',
    fontSize: '14px !important',
    boxSizing: 'border-box',
  },
}));


class NotificationEditor extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      activeStep: 0,
      languages: props.languages,
      sourceNotificationTitle: '',
      sourceNotificationBody: '',
      notificationTitle: '',
      notificationBody: '',
      notificationType: 'normal'
    };
  }

  componentDidMount() {

  }

  handleNext = () => {
    this.setState(state => ({
      activeStep: state.activeStep + 1,
    }));

    this.setDefaulData();
  };

  handleBack = () => {
    this.setState(state => ({
      activeStep: state.activeStep - 1,
    }));
  };

  handleReset = () => {
    const newData = {};
    this.props.languages.languages.forEach(val => {
      newData[`${val.id}NotificationTitle`] = '';
      newData[`${val.id}NotificationBody`] = '';
    });
    this.setState({
      activeStep: 0,
      sourceNotificationTitle: '',
      sourceNotificationBody: '',
      ...newData
    });
  };

  handleActive = (index) => {
    if(this.state.sourceNotificationTitle !== '' && this.state.sourceNotificationBody !== '') {
      this.setState({
        activeStep: index,
      });

      this.setDefaulData();
    }
  };

  handleChange = (name, id) => event => {
    this.setState({
      [name]: event.target.value
    });
  }

  setDefaulData = () => {
    const newData = {};
    this.props.languages.languages.forEach(lang => {
      if(!lang.base) {
        if(typeof this.state[`${lang.id}NotificationTitle`] === 'undefined') newData[`${lang.id}NotificationTitle`] = this.state.sourceNotificationTitle;
        if(typeof this.state[`${lang.id}NotificationBody`] === 'undefined') newData[`${lang.id}NotificationBody`] = this.state.sourceNotificationBody;
      }
    });
    this.setState({
      ...newData
    });
  }

  handleChangeType = event => {
    this.setState({ notificationType: event.target.value });
  };

  handleGenerateTemplate = () => {
    let notificationTitle, notificationBody;
    notificationTitle = notificationBody = (this.state.notificationType === 'normal') ? `{% case attributes.language %}` : `{% assign language = customer.tags | join: '' | split: 'ly#' %}{% case language[1] %}`;

    this.props.languages.languages.forEach(val => {
      if(!val.base) {
        notificationTitle += `{% when 'ly${val.id}' %}${this.state[val.id + 'NotificationTitle']}`;
        notificationBody += `{% when 'ly${val.id}' %}${this.state[val.id + 'NotificationBody']}`;
      }
    });

    notificationTitle += `{% else %}${this.state['sourceNotificationTitle']}{% endcase %}`;
    notificationBody += `{% else %}${this.state['sourceNotificationBody']}{% endcase %}`;

    this.setState({
      notificationTitle: notificationTitle,
      notificationBody: notificationBody,
      activeStep: this.props.languages.languages.length + 1,
    });
  }

  renderStep = (step, index) => {
    const { languages } = this.props;
    const { sourceNotificationTitle, sourceNotificationBody, activeStep } = this.state;

    const isLanguage = (typeof step === 'object');
    const namePrefix = step.id ? step.id : 'source';
    const titleState = this.state[`${namePrefix}NotificationTitle`];
    const bodyState = this.state[`${namePrefix}NotificationBody`];

    return(
      <Step key={step}>
        <StepLabel onClick={() => this.handleActive(index)}>
          {isLanguage ? `Translate: ${step.name}` : `Paste a Shopify notification template here`}
        </StepLabel>
        <StepContent>
          <TextField
            value={titleState}
            onChange={this.handleChange(`${namePrefix}NotificationTitle`, step.id ? step.id : null)}
            variant="outlined"
            fullWidth
            InputProps={{
              classes: {
                root: classNames(classes.textField, classes.disabledField),
                multiline: classes.textField,
                input: classes.inputField,
                inputMultiline: classes.inputField,
              }
            }}
          />
          <TextField
            value={bodyState}
            onChange={this.handleChange(`${namePrefix}NotificationBody`, step.id ? step.id : null)}
            variant="outlined"
            multiline
            rows={15}
            fullWidth
            InputProps={{
              classes: {
                root: classNames(classes.textField, classes.disabledField),
                multiline: classes.textField,
                input: classes.inputField,
                inputMultiline: classes.inputField,
              }
            }}
          />

          <div className={classes.actionsContainer}>
            <div>
              <Button
                variant="contained"
                color="primary"
                onClick={this.handleNext}
                className={classes.button}
                disabled={!(this.state.sourceNotificationTitle !== '' && this.state.sourceNotificationBody !== '')}
              >
                {activeStep === languages.languages.length - 1 ? 'Finish' : 'Next Step'}
              </Button>
            </div>
          </div>
        </StepContent>
      </Step>
    );
  }

  render() {
    const { languages } = this.props;
    const { activeStep } = this.state;

    return (
      <StyledPaper id="ItemsList" className={classes.root} elevation={1}>
        <Toolbar>
          Notification Generator
          {(this.state.sourceNotificationTitle !== '' && this.state.sourceNotificationBody !== '') &&
            <Button onClick={this.handleReset} className={classNames(classes.reset)}>
              Reset
            </Button>
          }
        </Toolbar>
        <Divider />
        <Stepper activeStep={activeStep} orientation="vertical">
          {this.renderStep('initial', 0)}
          {languages.languages.map((language, index) => {
            return !language.base ? this.renderStep(language, index) : null;
          })}
          <Step key={'finalize'}>
            <StepLabel onClick={() => this.handleActive(languages.languages.length)}>Finish the notification translation</StepLabel>
            <StepContent>
              <div className={classes.actionsContainer}>
                <FormControl component="fieldset" className={classes.formControl}>
                  <RadioGroup
                    aria-label="NotificationType"
                    name="notificationType"
                    className={classes.group}
                    value={this.state.notificationType}
                    onChange={this.handleChangeType}
                  >
                    <FormControlLabel value="normal" control={<Radio />} label="Regular Notification" />
                    <FormControlLabel value="customer" control={<Radio />} label="Customer Account Notification" />
                  </RadioGroup>
                </FormControl>
                <div>
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    onClick={this.handleGenerateTemplate}
                    className={classes.button}
                  >
                    Generate Notification Template
                  </Button>
                </div>
              </div>
            </StepContent>
          </Step>
        </Stepper>
        <Divider/>
        {activeStep === languages.languages.length + 1 && (
          <Paper square elevation={0} className={classes.resetContainer}>
            <div className={classNames('themes-section', classes.contentContainer)}>
              <TextField
                value={this.state.notificationTitle}
                onChange={() => {}}
                variant="outlined"
                rows={1}
                fullWidth
                disabled
                InputProps={{
                  classes: {
                    root: classNames(classes.textField, classes.disabledField),
                    multiline: classes.textField,
                    input: classes.inputField,
                    inputMultiline: classes.inputField,
                  }
                }}
              />
              <TextField
                value={this.state.notificationBody}
                onChange={() => {}}
                variant="outlined"
                multiline
                rows={15}
                fullWidth
                disabled
                InputProps={{
                  classes: {
                    root: classNames(classes.textField, classes.disabledField),
                    multiline: classes.textField,
                    input: classes.inputField,
                    inputMultiline: classes.inputField,
                  }
                }}
              />
            </div>
          </Paper>
        )}
      </StyledPaper>
    );
  }
}

NotificationEditor.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  languages: state.languages,
})

export default withRouter(connect(
  mapStateToProps,
  null
)(NotificationEditor));
